import * as React from 'react';
import { compose } from 'recompose';
import { createStyles } from '@material-ui/core/styles';
import { withBaseProps } from '../Utils';
import { border, toCssValue, transition } from '@topconagriculture/theme';
import { ButtonVariants } from './Button';
import { Button } from './index';
const styles = (theme) => createStyles({
    menuButton: {
        borderRadius: 0,
        borderBottom: border(theme.color.grey.light),
        padding: toCssValue([15, 20]),
        justifyContent: 'flex-start',
        transition: transition(100),
        '&:hover': {
            backgroundColor: theme.color.grey.lightest,
            paddingLeft: 30,
            textDecoration: 'none',
        },
        '&:last-child': {
            borderBottom: 0,
        },
    },
});
const PopoverMenuButton = (props) => {
    const { classes, action, destructiveAction, label, icon, loading, testId = 'PopoverMenuButton', disabled } = props;
    return (React.createElement(Button, { className: classes.menuButton, fullWidth: true, variant: destructiveAction ? ButtonVariants.error : ButtonVariants.branded, flat: true, onClick: action, iconName: icon, iconSize: 16, iconColor: 'inherit', label: label, isLoading: loading, disabled: disabled, "data-testid": `${testId}` }));
};
export default compose(withBaseProps({ styles }))(PopoverMenuButton);
//# sourceMappingURL=PopoverMenuButton.js.map